export default __webpack_public_path__ + "static/media/Twilio.0f7aceaf.svg";